import React$1 from 'react';
import { classNames, variationName } from '../../utilities/css.js';
import { Image as Image$1 } from '../Image/Image.js';
import styles from './Thumbnail.scss.js';

function Thumbnail({
  source,
  alt,
  size = 'medium'
}) {
  var className = classNames(styles.Thumbnail, size && styles[variationName('size', size)]);
  return /*#__PURE__*/React$1.createElement("span", {
    className: className
  }, /*#__PURE__*/React$1.createElement(Image$1, {
    alt: alt,
    source: source,
    className: styles.Image
  }));
}

export { Thumbnail };
